"use client";
import { motion } from "framer-motion";

export function AboutHero() {
  return (
    <section
      id="about-hero"
      className="relative pt-32 pb-24 bg-foreground dark:bg-card/30 transition-colors"
      data-header-scheme="dark"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="font-serif text-4xl md:text-6xl font-light text-background dark:text-foreground mb-6 tracking-tight">
            Premium Plaster & Microcement,
            <span className="block text-muted-foreground">
              Expert Connections
            </span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            The Plaster Shop is your trusted source for premium Concretta
            microcement products and America's leading directory connecting
            homeowners and designers with certified plaster applicators.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
